<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import ToastContainer from '@/components/ToastContainer.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'

const auth = useAuthStore()
const route = useRoute()

// Show login UI only if not authenticated AND not on callback page
const showLoginUI = computed(() => {
  return !auth.isAuthenticated && route.name !== 'callback'
})
</script>

<template>
  <div class="min-h-screen">
    <RouterView v-if="auth.isAuthenticated || route.name === 'callback'" />
    <div v-else-if="showLoginUI" class="min-h-screen flex items-center justify-center">
      <div class="text-center">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">BlackAndWhite</h1>
        <p class="text-gray-600 dark:text-gray-400 mb-6">Реестр негативных лиц</p>
        <button @click="auth.login()" class="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
          Войти через Keycloak
        </button>
      </div>
    </div>
  </div>
  <ToastContainer />
  <ConfirmModal />
</template>
